import { createFileRoute } from '@tanstack/react-router';
import { AuthCard, AuthShell } from '@/features/auth/layout/auth-layout';
import { RegisterForm } from '@/features/auth/forms/register-form';
import { RedirectIfAuthed } from '@/features/auth/components/redirect-if-authed';

export const Route = createFileRoute('/register')({
  component: RegisterPage,
});

function RegisterPage() {
  return (
    <RedirectIfAuthed>
      <AuthShell brandPane>
        <AuthCard title="Créer un compte">
          <RegisterForm />
        </AuthCard>
      </AuthShell>
    </RedirectIfAuthed>
  );
}
